import styled from 'styled-components';

type ReadMoreShowLessProps = {
  more?: boolean;
};

export const ReadMoreContainer = styled.div`
  position: relative;
`;

export const ReadMoreShowLess = styled.span<ReadMoreShowLessProps>`
  color: ${({ theme }) => theme.palette.primary[600]};
  font-weight: 600;
  cursor: pointer;
  padding-left: 4px;
  ${({ more, theme }) => more
  && `
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: ${theme.palette.base.background};
`}
`;

export const TextContainer = styled.span<ReadMoreShowLessProps>`
  text-align: justify;
  text-justify: inter-word;
  ${({ more }) => more
 && `
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  `}
`;
